import React from 'react'
import ReactNotify from 'react-notify'
let PropTypes = React.PropTypes
//Notify
import * as ReactNotifyCSS from '../../../shared/ReactNotify/ReactNotify.css'
//Service axios
import api from '../../../apiClient/v1'
//Componentes
import { ModalTrigger, ModalGasto, ModalInformarGastos } from './Modales.jsx'
import { DetalleTotales } from './totales/DetalleTotales.jsx'
import { TablaDetalleInventarios } from './ruta/TablaDetalleInventarios.jsx'
import { TablaDetalleFondo } from './distribucion/TablaDetalleFondo.jsx'
import { TablaGastos } from './gastos/TablaGastos.jsx'
//CSS
import css from '../FondosAsignados.css'
import classNames from 'classnames/bind'
let cx = classNames.bind(css)

export class DetalleFondo extends React.Component{
    constructor(props){
        super(props)
        this.state ={
            rendicion: {},
            gastos:[],
            lideres: [],
            idRendicion: 0,
            estado_rendicion: 0,
            idLiderSeleccionado: 0,
            numero_semana: 0,
            semanaSeleccionada: '',
            semana: [],
            inventarios: [],
            fondoSemana: [],
            semanaServicios: [],
            viaticosLiquidacion: 0,
            fondosRendir: 0,
            fondoPendiente: 0,
            fondoGirar: 0,
            comunaInicio: 0,
            totalColacionNocturna: 0,
            totalViatico: 0,
            totalAlojamiento: 0,
            totalAcercmientos: 0,
            totalTraslados: 0,
            totalPasajeOperador: 0,
            totalOtros: 0,
            cargando: false,
            totales: {
                viaticosLiquidacion: 0,
                fondosRendir: 0,
                fondoPendiente: 0,
                fondoGirar: 0
            },
            error: []
        }
        this.getRendicion = ()=>{
            //Get Rendicion
            api.rendiciones().detalleRendicion(this.props.idRendicion)
            .then(resp=>{
                this.setState({
                    rendicion: resp.rendicion,
                    gastos: resp.gastos
                })
            })
            .catch(err=>{
                console.log(err)
            })
        }
        this.getFondosInventarios = () => {
            api.fondos().getInventariosLider(this.props.idLider, this.props.fechaInicial, this.props.fechaFinal)
                .then(resp=>{
                    if(resp.inventarios.length > 0){
                        this.setState({
                            idRendicion: resp.idRendicion,
                            estado_rendicion: resp.estado_rendicion,
                            comunaInicio:resp.comunaInicio,
                            fondoPendiente: resp.saldoLider,
                            inventarios: resp.inventarios,
                            semanaServicios: resp.semanaServicios,
                            error: [],
                            cargando: false
                        }, ()=>this.sumaTotales())
                    }else{
                        this.refs.notificator.info("Fondos", "No hay inventarios en la semana seleccionada.", 5*1000)
                    }
                })
                .catch(err=>{
                    console.log(err)
                    this.setState({error: err.data})
                })
        }
    }
    sumaTotales(){
        let viaticosLiquidacion = 0
        let fondosRendir = 0
        let totalColacionNocturna = 0
        let totalViatico = 0
        let totalAlojamiento = 0
        let totalAcercmientos = 0
        let totalTraslados = 0
        let totalPasajeOperador = 0
        let totalOtros = 0
        let semanaServicios = this.state.semanaServicios

        semanaServicios.forEach(servicio => {
            if(servicio.colacion_nocturna && servicio.diaTrabajado){
                viaticosLiquidacion = parseInt(servicio.colacion_nocturna) + viaticosLiquidacion
                totalColacionNocturna = parseInt(servicio.colacion_nocturna) + totalColacionNocturna
            }
            if(servicio.viatico && servicio.diaTrabajado){
                viaticosLiquidacion = parseInt(servicio.viatico) + viaticosLiquidacion
                totalViatico = parseInt(servicio.viatico) + totalViatico
            }
            if(servicio.acercamientos && servicio.diaTrabajado){
                fondosRendir = parseInt(servicio.acercamientos) + fondosRendir
                totalAcercmientos = parseInt(servicio.acercamientos) + totalAcercmientos
            }
            if(servicio.alojamiento && servicio.diaTrabajado){
                viaticosLiquidacion = parseInt(servicio.alojamiento) + viaticosLiquidacion
                totalAlojamiento = parseInt(servicio.alojamiento) + totalAlojamiento
            }
            if(servicio.traslados && servicio.diaTrabajado && !servicio.pasajeSei){
                fondosRendir = parseInt(servicio.traslados) + fondosRendir
                totalTraslados = parseInt(servicio.traslados) + totalTraslados
            }
            if(servicio.pasajeOperador && servicio.diaTrabajado){
                fondosRendir = parseInt(servicio.pasajeOperador) + fondosRendir
                totalPasajeOperador = parseInt(servicio.pasajeOperador) + totalPasajeOperador
            }
            if(servicio.otros && servicio.diaTrabajado){
                fondosRendir = parseInt(servicio.otros) + fondosRendir
                totalOtros = parseInt(servicio.otros) + totalOtros
            }
        })

        let totales = {
            viaticosLiquidacion: viaticosLiquidacion,
            fondosRendir: fondosRendir,
            fondoPendiente: this.state.fondoPendiente,
            fondoGirar: (fondosRendir + viaticosLiquidacion) - (this.state.fondoPendiente? this.state.fondoPendiente : 0)
        }

        this.setState({
            totales,
            totalColacionNocturna,
            totalViatico,
            totalAlojamiento,
            totalAcercmientos,
            totalTraslados,
            totalPasajeOperador,
            totalOtros
        })
    }
    getChildContext(){
        return{
            nuevoGasto:(gasto)=>{
                let request = api.gastos().nuevoGasto(this.state.rendicion.idRendicion, gasto)
                request
                    .then(resp=>{
                        this.getRendicion()
                        this.refs.notificator.info("Rendiciones", "Gasto creado correctamente", 5*1000)
                    })
                    .catch(err=>{
                    })
                return request
            },
            getGasto:(idGasto)=>{
                return api.gastos().getGasto(idGasto)
            },
            modificarGasto:(gasto)=>{
                let request = api.gastos().modificarGasto(gasto.idGastoRendicion, gasto)
                request
                    .then(resp=>{
                        this.getRendicion()
                        this.refs.notificator.info("Rendiciones", "Gasto actualizado correctamente", 5*1000)
                    })
                    .catch(err=>{
                    })
                return request
            },
            subirFotoGasto:(foto)=>{
                let data = new FormData()
                data.append('fotoGasto', foto)
                return api.gastos().subirFotoGasto(data)
            },
            getTipoDocumentos:()=>{
                return api.gastos().getTipoDocumentos()
            },
            getTipoGastos:()=>{
                return api.gastos().getTipoGastos()
            }
        }
    }
    componentWillMount(){
        this.getRendicion()
        this.getFondosInventarios()
    }
    render() {
        return (
            <div className="container-fluid">
                <ReactNotify ref='notificator' className={ReactNotifyCSS}/>
                <div className="col-md-12 col-xs-12">
                    <div className="panel panel-default">
                        <div className="panel-body">
                            <div className="page-header row">
                                <div className={cx("col-md-12", 'titleMyFinancing')}>
                                    <div className={cx("col-md-12", 'divTitle')}>
                                        <h3><span className="glyphicon glyphicon-usd"></span> Fondo<b> Semana {this.state.rendicion.numero_semana} </b><p><small>{this.state.rendicion.fecha_inicial+" a "+this.state.rendicion.fecha_final}</small></p></h3>
                                    </div>
                                </div>
                            </div>
                            {this.state.inventarios.length === 0 ?
                                null
                                :
                                <div className={cx("col-md-12", 'divFinancing')}>
                                    <div className="row">
                                        <div className="col-md-11">
                                            <h5 className={css.textInformation}>Distribución de locales a inventariar*</h5>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-9">
                                            <TablaDetalleInventarios
                                                inventarios={this.state.inventarios}
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <DetalleTotales
                                                totales={this.state.totales}
                                            />
                                        </div>
                                    </div>
                                </div>
                            }
                            {this.state.inventarios.length === 0 ?
                                null
                                :
                                <div className={cx("col-md-12", 'divFinance')}>
                                    <div className="row">
                                            <div className="col-md-11">
                                            <h5 className={css.textInformation}>Distribución de fondos a utilizar*</h5>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <TablaDetalleFondo
                                            semanaServicios={this.state.semanaServicios}
                                            totalColacionNocturna={this.state.totalColacionNocturna}
                                            totalViatico={this.state.totalViatico}
                                            totalAlojamiento={this.state.totalAlojamiento}
                                            totalAcercmientos={this.state.totalAcercmientos}
                                            totalTraslados={this.state.totalTraslados}
                                            totalPasajeOperador={this.state.totalPasajeOperador}
                                            totalOtros={this.state.totalOtros}
                                            puedeModificar={false}
                                        />
                                    </div>
                                </div>
                            }
                            {/*
                             {this.state.gastos.length === 0 ?
                             null
                             :
                             <div className={cx("col-md-12", 'divFinance')}>
                             <div className="row">
                             <div className="col-md-11">
                             <h5 className={css.textInformation}>Listado de gastos asociados al fondo*</h5>
                             </div>
                             </div>
                             <div className="row">
                             <TablaGastos
                             gastos={this.state.gastos}
                             />
                             </div>
                             </div>
                             }
                            */}
                            
                        </div>
                    </div>    
                </div>
            </div>
        )
    }
}
DetalleFondo.childContextTypes = {
    nuevoGasto: PropTypes.func,
    getGasto: PropTypes.func,
    modificarGasto: PropTypes.func,
    subirFotoGasto: PropTypes.func,
    getTipoDocumentos: PropTypes.func,
    getTipoGastos: PropTypes.func
}


// WEBPACK FOOTER //
// ./frontEnd/operarios/fondos-asignados/detalle-fondo/DetalleFondo.jsx